import styled from "styled-components";

export const Container = styled.div``;

export const AlignmentRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;

  .options {
    display: flex;
    gap: 8px;
  }
`;

export const AlignmentButton = styled.button`
  padding: 16px 14px;
  border: 2px solid #262a34;
  border-radius: 12px;
  background-color: transparent;
  color: #fff;
  cursor: pointer;

  &[aria-pressed="true"] {
    border-color: #3a3f50;
    background-color: #3a3f50;
  }
`;

export const LimitNote = styled.p`
  margin-top: 12px;
  color: var(--color-neutral-light);
  font-size: 14px;
  line-height: 20px;
`;
